(function(){
  try {
    var KEY = 'so_society_member';
    var path = window.location.pathname;
    var SIGNUP = '/pages/join-the-society';
    if (path.indexOf('join-the-society') !== -1 || path.indexOf('/password') !== -1) return;
    var isSociety = path.indexOf('society') !== -1;
    if (isSociety && localStorage.getItem(KEY) !== 'true') {
      window.location.replace(SIGNUP);
    }
  } catch (e) {}
})();
